module.exports = __webpack_public_path__ + "static/media/golden-raffle-addons.f61f51c8.png";